"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fara-in-sabina": {
    "8ea575aa": [{
      "hkey": "0f9b159a",
      "slug": "fara-in-sabina",
      "name": "Fara in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "baccelli": [{
      "hkey": "0f9b159a",
      "slug": "fara-in-sabina",
      "name": "Fara in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d633cdc2": [{
      "hkey": "0f9b159a",
      "slug": "fara-in-sabina",
      "name": "Fara in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "collacchi": [{
      "hkey": "0f9b159a",
      "slug": "fara-in-sabina",
      "name": "Fara in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "648d3123": [{
      "hkey": "0f9b159a",
      "slug": "fara-in-sabina",
      "name": "Fara in Sabina",
      "primary": true,
      "skipSearch": false
    }],
    "villaggio-degli-ulivi": [{
      "hkey": "0f9b159a",
      "slug": "fara-in-sabina",
      "name": "Fara in Sabina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;